"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenRecordBeet = exports.TokenRecord = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const Key_1 = require("../types/Key");
const TokenState_1 = require("../types/TokenState");
const TokenDelegateRole_1 = require("../types/TokenDelegateRole");
const customSerializer = __importStar(require("../../custom/token-record-deserializer"));
class TokenRecord {
    constructor(key, bump, state, ruleSetRevision, delegate, delegateRole, lockedTransfer) {
        this.key = key;
        this.bump = bump;
        this.state = state;
        this.ruleSetRevision = ruleSetRevision;
        this.delegate = delegate;
        this.delegateRole = delegateRole;
        this.lockedTransfer = lockedTransfer;
    }
    static fromArgs(args) {
        return new TokenRecord(args.key, args.bump, args.state, args.ruleSetRevision, args.delegate, args.delegateRole, args.lockedTransfer);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return TokenRecord.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address, commitmentOrConfig) {
        const accountInfo = await connection.getAccountInfo(address, commitmentOrConfig);
        if (accountInfo == null) {
            throw new Error(`Unable to find TokenRecord account at ${address}`);
        }
        return TokenRecord.fromAccountInfo(accountInfo, 0)[0];
    }
    static gpaBuilder(programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
        return beetSolana.GpaBuilder.fromStruct(programId, exports.tokenRecordBeet);
    }
    static deserialize(buf, offset = 0) {
        return resolvedDeserialize(buf, offset);
    }
    serialize() {
        return resolvedSerialize(this);
    }
    static byteSize(args) {
        const instance = TokenRecord.fromArgs(args);
        return exports.tokenRecordBeet.toFixedFromValue(instance).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(TokenRecord.byteSize(args), commitment);
    }
    pretty() {
        return {
            key: 'Key.' + Key_1.Key[this.key],
            bump: this.bump,
            state: 'TokenState.' + TokenState_1.TokenState[this.state],
            ruleSetRevision: this.ruleSetRevision,
            delegate: this.delegate,
            delegateRole: this.delegateRole,
            lockedTransfer: this.lockedTransfer,
        };
    }
}
exports.TokenRecord = TokenRecord;
exports.tokenRecordBeet = new beet.FixableBeetStruct([
    ['key', Key_1.keyBeet],
    ['bump', beet.u8],
    ['state', TokenState_1.tokenStateBeet],
    ['ruleSetRevision', beet.coption(beet.u64)],
    ['delegate', beet.coption(beetSolana.publicKey)],
    ['delegateRole', beet.coption(TokenDelegateRole_1.tokenDelegateRoleBeet)],
    ['lockedTransfer', beet.coption(beetSolana.publicKey)],
], TokenRecord.fromArgs, 'TokenRecord');
const serializer = customSerializer;
const resolvedSerialize = typeof serializer.serialize === 'function'
    ? serializer.serialize.bind(serializer)
    : exports.tokenRecordBeet.serialize.bind(exports.tokenRecordBeet);
const resolvedDeserialize = typeof serializer.deserialize === 'function'
    ? serializer.deserialize.bind(serializer)
    : exports.tokenRecordBeet.deserialize.bind(exports.tokenRecordBeet);
//# sourceMappingURL=TokenRecord.js.map